// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"9cc491b8","276":"d8776d66","386":"d848cadc","409":"245be947","453":"926f0775","592":"70bf5a64","635":"230958b6","736":"7e775089","987":"f9f41d31"}[chunkId] + ".chunk.js";
};